import { mapGetters, mapState, mapActions } from 'vuex'
import VirtualList from 'vue-virtual-scroll-list'
import globaltypes from '../../store/globaltypes'
import card from '../../components/card'
import cropcard from '../../components/cropcard'

export default {
  name: 'crops',
  components: { card, 'virtual-list': VirtualList },
  props: [],
  data () {
    return {
      itemComponent: cropcard,
      filter: null
    }
  },
  computed: {
    ...mapState({
      isLoading: state => !state.ui.crops.isDataLoaded,
      cropsFilter: state => state.crops.filter
    }),
    ...mapGetters({
      filteredCrops: globaltypes.crops.getters.filteredCrops,
      cropGroups: globaltypes.crops.getters.cropgroups
    }),
    filters () {
      return [ this.$t('crops.all_crops'), ...this.cropGroups ]
    },
    numVisibleItems () {
      return 4 + Math.ceil((window.innerHeight) / 72)
    },
    crops () {
      return this.filteredCrops.map(x => ({
        key: x.key,
        name: x.post_title,
        image: x.image,
        description: x.crop_group ? x.crop_group.join(', ') : ''
      }))
    }
  },
  watch: {
    $route (to) {
      if (to.name === 'crops') {
        console.log('to crops', this.cropsFilter)
        this.filter = this.cropsFilter
      }
    },
    filter (val) {
      let index = this.cropGroups.indexOf(val)
      if (index === -1) this.filterCrops(null)
      else this.filterCrops(val)
    }
  },
  methods: {
    ...mapActions({
      filterCrops: globaltypes.crops.actions.filter
    })
  }
}
